(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("assignmentLearnerAccessOnlineExamResource", ["$resource", assignmentLearnerAccessOnlineExamResource]);
    function assignmentLearnerAccessOnlineExamResource($resource) {
        return $resource("/api/onlineExamAssignments/:id/:number/:version/:code/learnerAccess/:action", { id: "@id" }, {
            requestAttempt: {
                method: "POST",
                params: {
                    action: "requestAttempt"
                }
            },
            redeemExamAttemptCode: {
                method: "POST",
                params: {
                    action: "redeemExamAttemptCode"
                }
            },
            getAvailableExamSessions: {
                method: "GET",
                params: {
                    number: "@number",
                    version: "@version",
                    code: "@code",
                    action: "getAvailableExamSessions"
                }
            },
            enroll: {
                method: "POST",
                params: {
                    number: "@number",
                    version: "@version",
                    code: "@code",
                    action: "enrollExamSession"
                }
            },
            withdraw: {
                method: "POST",
                params: {
                    action: "withdrawFromExamSession"
                }
            }
        });
    }
    ;
}());
